import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const DownloadsListHeader = ({ profile }) => {
  const intl = useIntl();

  return (
    <tr>
      <th>
        {intl.formatMessage({ defaultMessage: 'ID' })}
      </th>
      <th className="download-date">
        {intl.formatMessage({ defaultMessage: 'Downloaded' })}
      </th>
      {profile.is_admin && (
        <th className="download-user-name">
          {intl.formatMessage({ defaultMessage: 'User' })}
        </th>
      )}
      <th className="download-files">
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

DownloadsListHeader.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default DownloadsListHeader;
